export default __webpack_public_path__ + "static/media/laporan-cabang.8cc7d49b.png";